module.exports = __webpack_public_path__ + "static/media/Mapa-Espírito Santo.150d0985.svg";